module.exports = __webpack_public_path__ + "img/banner-index-2.318543d9.jpg";